module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/icon-amazon_a5a8d52.png";